import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  Form,
  FormGroup,
  Label,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
} from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";

const Update = ({ title, onSubmit, fields, initialData, parentTitle,isAlert = false }: any) => {
  const navigate = useNavigate();
  const { Id } = useParams();
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [selectedValues, setSelectedValues] = useState<Record<string, any>>({});
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const [formData, setFormData] = useState<any>(null);
  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  useEffect(() => {
    if (initialData) {
     
      setFormData(initialData);

      fields.forEach((field: any) => {
        if (initialData[field.name]) {
          setValue(field.name, initialData[field.name]);

          // ✅ Set initial selected value for dropdowns
          if (field.isDropdown && field.dropdownData) {
            const selectedItem = field.dropdownData.find((item: any) => {
              // Prefer matching by ID if available
              if (field.idFieldName && initialData[field.idFieldName]) {
                return item.id === initialData[field.idFieldName];
              } else {
                return (
                  item[field.dropdownLabel || "name"] === initialData[field.name]
                );
              }
            });

            if (selectedItem) {
              setSelectedValues(prev => ({
                ...prev,
                [field.name]: selectedItem,
              }));
            }
          }
        }
      });
    }
  }, [initialData, setValue, fields]);

  const handleFormSubmit = async (data: any) => {
    try {
      const formData = { ...data };

      fields.forEach((field: any) => {
        if (field.isDropdown && selectedValues[field.name]) {
          formData[field.name] = selectedValues[field.name][field.dropdownLabel];

          if (field.idFieldName) {
            formData[field.idFieldName] = selectedValues[field.name].id;
          } else {
            formData[`${field.name}Id`] = selectedValues[field.name].id;
          }
        }
      });

      await onSubmit(formData);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const toggleDropdown = (fieldName: string) => {
    setActiveDropdown(activeDropdown === fieldName ? null : fieldName);
  };

  const handleSelectDropdownValue = (item: any, fieldName: string) => {
    setSelectedValues(prev => ({
      ...prev,
      [fieldName]: item,
    }));
    setValue(fieldName, item[fields.dropdownLabel || "name"]);
    setActiveDropdown(null);
  };

  return (
    <>
      <Breadcrumbs mainTitle={title} parent={parentTitle} />
      <div style={{ width: "100%" }}>
        <Card className="p-3">
          <CommonCardHeader title={title} headClass="pb-3" />
 {isAlert?<Alert color="info"  isOpen={visible} toggle={onDismiss}>Please note that after a DUID is updated or added, it may take up to 5 minutes for the changes to be reflected on the control panel.</Alert>:null}
          <Form onSubmit={handleSubmit(handleFormSubmit)}>
            {fields
              .reduce((rows: any[][], field: any, index: number) => {
                if (index % 2 === 0) rows.push([field]);
                else rows[rows.length - 1].push(field);
                return rows;
              }, [])
              .map((row: any, rowIndex: any) => (
                <div className="row" key={rowIndex}>
                  {row.map((field: any, colIndex: number) => (
                    <div className="col-md-6 mb-3" key={`${field.name}-${colIndex}`}>
                      <FormGroup>
                        <Label className="col-form-label">{field.label}</Label>

                        {field.isDropdown ? (
                          <Dropdown
                            isOpen={activeDropdown === field.name}
                            toggle={() => toggleDropdown(field.name)}
                            className="custom-dropdown-wrapper"
                          >
                            <DropdownToggle
                              color="primary"
                              className="custom-dropdown-toggle d-flex align-items-center justify-content-between"
                              style={{
                                backgroundColor: "#007bff",
                                borderColor: "#007bff",
                                color: "#fff",
                                fontWeight: 500,
                                borderRadius: "6px",
                                padding: "8px 16px",
                                width: "200px",
                              }}
                            >
                              <span>
                                {selectedValues[field.name]
                                  ? selectedValues[field.name][field.dropdownLabel || "name"]
                                  : `Select ${field.label}`}
                              </span>
                            </DropdownToggle>

                            <DropdownMenu
                              className="custom-dropdown-menu"
                              style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                                boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.1)",
                                borderRadius: "8px",
                                padding: "8px 0",
                              }}
                            >
                              {field.dropdownData?.map((item: any) => (
                                <DropdownItem
                                  key={item.id}
                                  onClick={() => handleSelectDropdownValue(item, field.name)}
                                  className="custom-dropdown-item"
                                  style={{
                                    padding: "8px 16px",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {item[field.dropdownLabel]}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        ) : (
                          <input
                            className="form-control"
                            type={field.type}
                            {...register(field.name, field.validation)}
                          />
                        )}

                        {errors[field.name] && (
                          <p className="text-danger mt-1">
                            {errors[field.name]?.message?.toString()}
                          </p>
                        )}
                      </FormGroup>
                    </div>
                  ))}
                </div>
              ))}

            <div className="form-group mb-0">
              <div className="d-flex justify-content-start mt-3">
                <Button color="primary" type="submit" className="me-1">
                  Update
                </Button>
                <Button color="danger" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default Update;
